<template>
  <div id="app">
    <keep-alive>
      <transition :name="routerTransitionName">
        <router-view class="Router" />
      </transition>
    </keep-alive>
  </div>
</template>

<script>
import utils from './utils'
export default {
  name: 'App',
  data () {
    return {
      routerTransitionName: 'slideRight'
    }
  },
  mounted () {
    utils.share(
      `${location.protocol}//m.9kacha.com/wxsvr/wxjsapi/getSignPackage.php?url=${encodeURIComponent(location.href)}`,
      'https://activity.9kacha.com/ITWE-Yantai/static/share-logo.png',
      '重磅尊享福利！立即报名烟台酒博会酒咔嚓特别参观团',
      '免费住宿、车站接送、酒庄旅游...都有！'
    )
  },
  watch: {
    '$route' (to, from) {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0

      this.routerTransitionName = to.name === 'index'
        ? 'slideLeft'
        : 'slideRight'
    }
  }
}
</script>

<style lang="less">
  @import "less/normalize.less";
  @import "less/common.less";
  /*@import "less/mint-ui-custom";*/
  @import "less/vue2-animate";
  #app {
    position: relative;
    font-size: 14px;
    width: 100%;
    .Router {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      min-height: 100vh;
    }
    .slideLeft-enter-active,
    .slideLeft-leave-active,
    .slideRight-enter-active,
    .slideRight-leave-active {
      animation-duration: 0.5s;
      animation-fill-mode: both;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue